import { fallbackApps } from "../fallback/contentFallbacks";
import { mapWordPressApp } from "../mappers/wordpressMappers";
import { createServiceResult } from "./serviceResult";
import { fetchAppBySlug, fetchApps } from "../wordpress/wordpressApi";

function filterApps(apps, options = {}) {
  return apps.filter((app) => {
    const matchesSearch = options.search
      ? `${app.name} ${app.summary}`.toLowerCase().includes(options.search.toLowerCase())
      : true;
    const matchesCategory = options.category
      ? app.category === options.category
      : true;
    const matchesPlatform = options.platform
      ? app.platform.includes(options.platform)
      : true;

    return matchesSearch && matchesCategory && matchesPlatform;
  });
}

export async function getApps(options = {}) {
  try {
    const response = await fetchApps(options);
    const items = filterApps(response.data.map(mapWordPressApp), options);

    return createServiceResult({
      data: items,
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: filterApps(fallbackApps, options),
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}

export async function getAppBySlug(slug, options = {}) {
  try {
    const response = await fetchAppBySlug(slug, options);
    const app = response.data.map(mapWordPressApp)[0] || null;

    return createServiceResult({
      data: app,
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: fallbackApps.find((item) => item.slug === slug) || null,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}
